import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum HandoutEventFields {
    INSTITUTION = 'institution',
    INSTITUTION_HAS_CONFIRMED = 'institutionHasConfirmed',
    INSTITUTION_IS_ADVERTISER = 'institutionIsAdvertiser',
    COORDINATOR = 'coordinator',
    COORDINATOR_HAS_CONFIRMED = 'coordinatorHasConfirmed',
    ADVERTISER = 'advertiser',
    ADVERTISER_HAS_CONFIRMED = 'advertiserHasConfirmed',
    TEACHER = 'teacher',
    TEACHER_HAS_CONFIRMED = 'teacherHasConfirmed',
    EVENT_DATE = 'eventDate',
    EVENT_START_TIME = 'eventStartTime',
    EVENT_END_TIME = 'eventEndTime',
    HANDOUT = 'handout',
    HANDOUT_PRINTED = 'handoutPrinted',
    HANDOUT_SENT = 'handoutSent',
    EVENT_TOOK_PLACE = 'eventTookPlace',
    COURSE_START_DATE = 'courseStartDate',
    RETURNING_DATE = 'returningDate',
    HAS_RETURNED = 'hasReturned',
    IS_DELAYED = 'isDelayed',
    RETURNING_AMOUNT = 'returningAmount',
    IS_ACTIVE = 'isActive',
    PROTOCOL = 'protocol',

    COORDINATOR_REMOTE_CONFIRMATION = 'coordinatorRemoteConfirmation',
    ADVERTISER_REMOTE_CONFIRMATION = 'advertiserRemoteConfirmation',
    TEACHER_REMOTE_CONFIRMATION = 'teacherRemoteConfirmation',
    INSTITUTION_REMOTE_CONFIRMATION = 'institutionRemoteConfirmation',

    ADVERTISER_FEEDBACK = 'advertiserFeedback',
    INSTITUTION_FEEDBACK = 'institutionFeedback',

    REMINDER_CONFIG = 'reminderConfig',

    /** Persons marked as "fällt aus" after a Krankmeldung im Lehrkraft-Bereich */
    UNAVAILABLE = 'unavailable',
    PLANNING_ROUND = 'planningRound',
    DATE_REQUEST = 'dateRequest',

    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
    
    HAS_OPEN_ACTIVITIES = 'hasOpenActivities',
}

export namespace HandoutEventFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<HandoutEventFields, Data> = {
        [HandoutEventFields.INSTITUTION]: {
            text: 'Institution',
        },
        [HandoutEventFields.INSTITUTION_HAS_CONFIRMED]: {
            text: 'Institution hat bestätigt',
        },
        [HandoutEventFields.INSTITUTION_IS_ADVERTISER]: {
            text: 'Institution ist Werbetreibender',
        },
        [HandoutEventFields.COORDINATOR]: {
            text: 'Koordinator',
        },
        [HandoutEventFields.COORDINATOR_HAS_CONFIRMED]: {
            text: 'Koordinator hat bestätigt',
        },
        [HandoutEventFields.ADVERTISER]: {
            text: 'Werbetreibender',
        },
        [HandoutEventFields.ADVERTISER_HAS_CONFIRMED]: {
            text: 'Werbetreibender hat bestätigt',
        },
        [HandoutEventFields.TEACHER]: {
            text: 'Lehrer',
        },
        [HandoutEventFields.TEACHER_HAS_CONFIRMED]: {
            text: 'Lehrer hat bestätigt',
        },
        [HandoutEventFields.EVENT_DATE]: {
            text: 'Veranstaltungsdatum',
        },
        [HandoutEventFields.EVENT_START_TIME]: {
            text: 'Veranstaltungsbeginn',
        },
        [HandoutEventFields.EVENT_END_TIME]: {
            text: 'Veranstaltungsende',
        },
        [HandoutEventFields.HANDOUT]: {
            text: 'Handout',
        },
        [HandoutEventFields.HANDOUT_PRINTED]: {
            text: 'Handout gedruckt',
        },
        [HandoutEventFields.HANDOUT_SENT]: {
            text: 'Handout gesendet',
        },
        [HandoutEventFields.EVENT_TOOK_PLACE]: {
            text: 'Veranstaltung hat stattgefunden',
        },
        [HandoutEventFields.COURSE_START_DATE]: {
            text: 'Kursbeginn',
        },
        [HandoutEventFields.RETURNING_DATE]: {
            text: 'Rückgabedatum',
        },
        [HandoutEventFields.HAS_RETURNED]: {
            text: 'Wurde zurückgegeben',
        },
        [HandoutEventFields.IS_DELAYED]: {
            text: 'Ist verspätet',
        },
        [HandoutEventFields.RETURNING_AMOUNT]: {
            text: 'Rückgabemenge',
        },
        [HandoutEventFields.IS_ACTIVE]: {
            text: 'Ist aktiv',
        },
        [HandoutEventFields.PROTOCOL]: {
            text: 'Protokoll',
        },
        [HandoutEventFields.COORDINATOR_REMOTE_CONFIRMATION]: {
            text: 'Koordinator Fernbestätigung',
        },
        [HandoutEventFields.ADVERTISER_REMOTE_CONFIRMATION]: {
            text: 'Werbetreibender Fernbestätigung',
        },
        [HandoutEventFields.TEACHER_REMOTE_CONFIRMATION]: {
            text: 'Lehrer Fernbestätigung',
        },
        [HandoutEventFields.INSTITUTION_REMOTE_CONFIRMATION]: {
            text: 'Institution Fernbestätigung',
        },
        [HandoutEventFields.ADVERTISER_FEEDBACK]: {
            text: 'Werbetreibender Feedback',
        },
        [HandoutEventFields.INSTITUTION_FEEDBACK]: {
            text: 'Institution Feedback',
        },
        [HandoutEventFields.REMINDER_CONFIG]: {
            text: 'Erinnerungskonfiguration',
        },
        [HandoutEventFields.UNAVAILABLE]: {
            text: 'Fällt aus (Krankmeldung)',
        },
        [HandoutEventFields.PLANNING_ROUND]: {
            text: 'Austeilrunde',
            readOnly: true,
        },
        [HandoutEventFields.DATE_REQUEST]: {
            text: 'Terminwahl der Schule',
            readOnly: true,
        },
        [HandoutEventFields.CREATED_AT]: {
            text: 'Erstellt am',
        },
        [HandoutEventFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
        },
        [HandoutEventFields.HAS_OPEN_ACTIVITIES]: {
            text: 'Hat offene Aktivitäten',
        },
    }

    export const Items = mapRecordToItems(Record);
}
